<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  min-width: 1366px;
  min-height: 600px;
  overflow: auto;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.top {
  width: 100%;
  height: 50px;
  line-height: 50px;
}

.title {
  width: 100%;
  height: 100%;
  color: #666;
  background: #fff;
  font-size: 16px;
  font-weight: bold;
  position: relative;
  box-sizing: border-box;
}

.title span {
  display: inline-block;
  width: 4px;
  height: 20px;
  background: #409eff;
  position: absolute;
  top: 15px;
  left: 20px;
}

.title p {
  display: inline-block;
  width: auto;
  height: 50px;
  position: absolute;
  top: 0;
  left: 30px;
  text-align: left;
}
</style>
